import { PublicClientApplication } from "@azure/msal-browser";

const isLocalhost = window.location.hostname === 'localhost';

// Configuración de MSAL
export const msalConfig = {
    auth: {
        clientId: "a402b8df-7b4c-437b-9601-0648f1598f47",
        authority: "https://login.microsoftonline.com/f21334b0-75de-4641-8e59-3c0e5a7ab753",
        redirectUri: isLocalhost ? "http://localhost:3000" : "https://desbloqueos.educacioncba.edu.ar",
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    }
};

// Crear la instancia de MSAL
export const msalInstance = new PublicClientApplication(msalConfig);

// Otras configuraciones
export const loginRequest = {
    scopes: ["User.Read"]
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
